import contractObject from '@/decentralizedApi/inits.js'
import v2Router from '@/config/abi/v2Router.json';
import v2Pair from '@/config/abi/v2Pair.json';
import erc20Abi from '@/config/abi/erc20.json';
import wethAbi from '@/config/abi/weth.json';
import v2FactoryAbi from '@/config/abi/v2Factory.json';

import {getFactoryAddress, getRouterAddress, getWethAddress} from '@/utils/addressHelp';


const getContract = (abi, address) =>   {
  const web3Provider = contractObject.getWeb3ModalProvider(false);
  return new web3Provider.eth.Contract(abi, address);
};

export let getErc20Contract = (address) => {
  return getContract(erc20Abi, address);
};

export let getRouterContract = () => {
  return getContract(v2Router, getRouterAddress());
};

export let getFactoryContract = () => {
  return getContract(v2FactoryAbi, getFactoryAddress());
};

export let getPairContract = (address) => {
  return getContract(v2Pair, address);
};

export let getWethContract = () => {
  return getContract(wethAbi, getWethAddress());
};
